<template>
  <div class="space-y-3">
    <div class="deviceInfo">
      <div class="flex items-center gap-2">
        <img src="@/assets/images/device/battery.svg" alt="" />
        <p class="title">Battery</p>
      </div>
      <div class="status">
        <p class="text-white text-sm">81%</p>
      </div>
    </div>
    <div class="deviceInfo">
      <div class="flex items-center gap-2">
        <img src="@/assets/images/device/blutuz.svg" alt="" />
        <p class="title">Bluetooth</p>
      </div>
      <div class="status">
        <p class="text-white text-sm">ON</p>
      </div>
    </div>
    <div class="deviceInfo">
      <div class="flex items-center gap-2">
        <img src="@/assets/images/device/eld.svg" alt="" />
        <p class="title">Eld Connecttion</p>
      </div>
      <div class="status">
        <p class="text-white text-sm">ON</p>
      </div>
    </div>
    <div class="deviceInfo">
      <div class="flex items-center gap-2">
        <img src="@/assets/images/device/gps.svg" alt="" />
        <p class="title">GPS Permission</p>
      </div>
      <div class="status">
        <p class="text-white text-sm">ON</p>
      </div>
    </div>
    <div class="deviceInfo">
      <div class="flex items-center gap-2">
        <img src="@/assets/images/device/location.svg" alt="" />
        <p class="title">Location</p>
      </div>
      <div class="status">
        <p class="text-white text-sm">ON</p>
      </div>
    </div>
    <div class="deviceInfo">
      <div class="flex items-center gap-2">
        <img src="@/assets/images/device/microphone.svg" alt="" />
        <p class="title">Microphone</p>
      </div>
      <div class="status inactive">
        <p class="text-white text-sm">OFF</p>
      </div>
    </div>
    <div class="deviceInfo">
      <div class="flex items-center gap-2">
        <img src="@/assets/images/device/storage.svg" alt="" />
        <p class="title">Storage</p>
      </div>
      <div class="status">
        <p class="text-white text-sm">ON</p>
      </div>
    </div>
    <div class="deviceInfo">
      <div class="flex items-center gap-2">
        <img src="@/assets/images/device/sound.svg" alt="" />
        <p class="title">System Sound</p>
      </div>
      <div class="status inactive">
        <p class="text-white text-sm">OFF</p>
      </div>
    </div>
    <div class="deviceInfo">
      <div class="flex items-center gap-2">
        <img src="@/assets/images/device/time.svg" alt="" />
        <p class="title">System Time</p>
      </div>
      <p class="text-sm">2024-08-09/09:45 AM</p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      infos: [
        {
          title: "Battery",
        },
      ],
    };
  },
};
</script>
<style lang="scss" scoped>
.deviceInfo {
  display: flex;
  align-items: center;
  justify-content: space-between;
  img {
    width: 20px;
    height: 20px;
  }
  .title {
    font-family: Inter;
    font-size: 16px;
    font-weight: 300;
    line-height: 14.52px;
    text-align: left;
    color: #000000;
  }
  .status {
    padding: 2px 12px 2px 12px;
    border-radius: 15px;
    background: #06a449;
    &.inactive {
      background: #f22e1f;
    }
  }
}
</style>